import { mapGetters } from 'vuex'
import Stat from '@/components/Stat.vue'
import Utils from '@/utils/charts'
export default {
  components: {
    Stat
  },
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      datasets: 'skiliko/metrics/datasets'
    }),
    dataset () {
      const key = Utils.datasetIdentifier(this.dataKey, this.params)
      return this.datasets[key] || {}
    },
    loading () {
      return !this.dataset || this.dataset.loading
    },
    from () {
      if (!this.dataset.query) { return null }
      return new Date(this.dataset.query['start-date'])
    },
    to () {
      if (!this.dataset.query) { return null }
      return new Date(this.dataset.query['end-date'])
    },
    total () {
      return this.dataset.totalsForAllResults
    },
    totalResults () {
      return this.dataset.totalResults
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/stats.js